<template>
  <div class="video-uploader">
    <a-upload
        accept="video/mp4"
        :action="uploadUrl"
        :headers="uploadHeaders"
        list-type="picture-card"
        :default-file-list="fileList"
        :before-upload="beforeUpload"
        @preview="handlePreview"
        :remove="handleRemove"
        @change="handleChange"
    >
      <div v-if="fileList.length<num" :style="'width: '+width+'px;height: '+height+'px;'+'line-height:'+height+'px;'">
        <div class="ant-upload-text"><a-icon type="plus"/>上传视频</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <video controls style="width: 100%;margin: 0 auto;max-height: 800px;padding:10px">
        <source :src="videoUrl" type="video/mp4">
        您的浏览器不支持视频播放
      </video>
    </a-modal>
  </div>
</template>

<script>
import {Form} from "ant-design-vue";
import {uploadVideo} from "@/api/Home.js";
import cookieStore from "@/utils/store/cookie";
import { buildUploadUrl } from "@/utils/uploadUrl";
export default {
  name: 'UploadVideo',
  props: {
    value: {
      type: String,
      default: "",
    },
    // 素材限制数量，默认5个
    num: {
      type: Number,
      default() {
        return 1
      }
    },
    // 宽度
    width: {
      type: Number,
      default() {
        return 104
      }
    },
    // 宽度
    height: {
      type: Number,
      default() {
        return 104
      }
    }
  },
  data() {
    return {
      uploadUrl: buildUploadUrl('/api/upload'),
      fileList: [],
      previewVisible: false,
      videoUrl: ''
    }
  },
  computed: {
    uploadHeaders() {
      const token =
        this.$store?.state?.app?.token ||
        cookieStore.get("login_status") ||
        localStorage.getItem("token") ||
        "";
      return token ? { Authorization: `Bearer ${token}` } : {};
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal!=null&& newVal!='') {
          const urls = newVal.split(",");
          this.fileList = urls.map((url, index) => ({
            uid: `-${index}`, // 唯一标识
            name: `image-${index}.mp4`,
            status: "done",
            url: url,
            type:'video/mp4'
          }));
        } else {
          this.fileList = [];
        }
      },
    },
  },
  methods: {

    handleChange(info) {
      console.log("状态变化：")
      console.log(info)
      let fileList=info.fileList
      if (info.file.status === 'done') {
        const imageUrl =  info.file.response?.link || '';
        if (imageUrl) {
          this.fileList = [...this.fileList, {
            uid: info.file.uid,
            name: info.file.name,
            status: "done",
            url: imageUrl,
            type:'video/mp4'
          }];
          fileList=fileList.map((file)=>{
            file.url=imageUrl
            return file;
          })
          // this.fileList.push({
          //   uid: info.file.uid,
          //   name: info.file.name,
          //   status: "done",
          //   url: imageUrl,
          // })
          this.emitValue();
        }
        this.$message.success(`${info.file.name} 上传成功!`);
      }
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('video')
      const isLt2M = file.size / 1024 / 1024 < 50

      if (!isImage) {
        this.$message.error('上传视频只能是视频格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传视频大小不能超过 50MB!')
      }
      if (this.fileList.length > this.num) {
        this.$message.error(`最多只能上传 ${this.num} 个视频！`);
      }
      return isImage && isLt2M
    },

    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {

      console.log("点击预览视频文件：")
      console.log(file)

      this.previewVisible = true
      this.videoUrl = file.url;

    },
    async handleRemove(file){
      console.log("删除视频")
      console.log(file)
      this.fileList.splice(file.uid, 1);
      this.emitValue(); // 更新父组件的值
    },

    // 更新父组件的值
    emitValue() {
      const videoUrls = this.fileList.map((file) => file.url).join(",");
      this.$emit("input", videoUrls);
    },

  }
}
</script>

<style scoped>

/* 覆盖默认缩略图 */
:deep(.ant-upload-list-picture-card .ant-upload-list-item-thumbnail) {
  //display: none !important;
  //background-image: url("~@/assets/images/video.png");
}

:deep(.ant-upload-list-picture-card .ant-upload-list-item) {
  //padding: 8px;
  background-image: url("~@/assets/images/video.png");
  background-size: 100px 100px;
}
</style>
